import { Icon } from '@thro-types/users';

import { Gateway } from 'index';

interface S3UploadProps {
  file: Blob;
  icon: Icon;
}

export const uploadAttachmentToS3 = async ({ file, icon }: S3UploadProps) => {
  const formData = new FormData();
  if (file instanceof Blob) {
    formData.append('file', file);
    formData.append('isRounded', String(icon.isRounded));
    if (icon.isDefault) {
      formData.append('isDefault', String(icon.isDefault));
    }
  }

  const { data }: { data: Icon } = await Gateway.putForm(`/users/v1/icons`, formData);

  return data;
};
